import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._12,
  },

  title: {
    textAlign: 'center',
  },

  timeContainer: {
    display: 'flex',
    gap: theme.spacing.sm,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  timeBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.colors.gold[7],
    borderRadius: theme.radius.sm,
    padding: `10px`,
    minWidth: '60px',
  },

  timeValue: {
    color: theme.colors.gold[0],
  },

  timeLabel: {
    color: theme.colors.gold[3],
    textTransform: 'uppercase',
  },

  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: theme.spacing.xs,
  },
}));

export default useStyles;
